export default __webpack_public_path__ + "static/media/title-topp-butikker.699880a0.png";